<template>
  <div>
    <Head :title="$t('locations.locations')"/>
    <h1 class="mb-8 text-3xl font-bold">{{ $t('locations.locations') }}</h1>
    <Table
      :resource="data"
      class="custom-table-layout rounded"
      url-to-view="locations"
    >
      <template v-slot:extraButtons>
        <Link class="btn-indigo inline-flex items-center mr-2" href="/locations/create" style="height: 38px">
          <icon name="plus" class="w-4 h-4 fill-current text-white mr-2" />
          <span class="capitalize">{{$t('locations.new')}}</span>
        </Link>
      </template>
      <template #cell(types)="{ item: location }">
        {{ location.types.join(', ') }}
      </template>
    </Table>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Table from '@/Shared/Table/Components/Table'

export default {
  components: {
    Head,
    Icon,
    Link,
    Table,
  },
  layout: Layout,
  props: {
    data: Object,
  }
}
</script>
